import React from "react";
import TermsOfServiceContainer from "./TermsOfService.container";

const TermsOfService: React.FC = () => <TermsOfServiceContainer />;

export default TermsOfService;
